import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/roof-cleaning-saratoga-springs-ny")({
  beforeLoad: () => {
    throw redirect({ to: "/roof-washing-saratoga-springs-ny", statusCode: 301 });
  },
});
